/** Width of the AI side panel in pixels — single source of truth for SidePanel.vue and App.vue. */
export const SIDE_PANEL_WIDTH_PX = 400
export const SIDE_PANEL_WIDTH_CLASS = 'w-[400px]'

/**
 * Duration of the docked ↔ overlay reshape transition in milliseconds.
 *
 * Owned here instead of being hardcoded next to each consumer so the JS arming window in
 * :file:`components/ui/SidePanel.vue` (which gates the ``.side-panel-shell--reshaping``
 * class long enough for the CSS transition to run) and the CSS ``transition: left 300ms``
 * declaration in the same file's ``<style>`` block can no longer drift apart silently.
 *
 * If you change this value, also bump the matching CSS ``transition`` durations in
 * :file:`components/ui/SidePanel.vue` — Vue SFC scoped styles cannot interpolate JS
 * constants directly, so the CSS side has to be edited by hand and the comment in that
 * file's style block calls out the dependency.
 */
export const SIDE_PANEL_RESHAPE_DURATION_MS = 300

/**
 * Buffer added to :const:`SIDE_PANEL_RESHAPE_DURATION_MS` for the ``isReshaping`` clear
 * timer. Keeps the transition class attached for one frame past the CSS transition's
 * declared end so the browser actually paints the final position before we drop the
 * transition declaration — without the buffer the class can be removed exactly on the
 * frame the transition ends, which on slower devices reads as a sub-pixel snap.
 */
export const SIDE_PANEL_RESHAPE_BUFFER_MS = 20
